import type { KhoaDich } from '../../i18n';
import type { BienTheTrangThai } from './constants';

/**
 * Bảng tông của màn Kho dữ liệu (ADR-0086). Nằm ở đây chứ không ở `src/mock/` (CLAUDE.md).
 */

/** Độ chắc chắn của một đề xuất dò được: khá chắc xanh, cần xem lại hổ phách, phỏng đoán xám. */
export const MUC_CHAC: Record<'cao' | 'vua' | 'thap', { khoa: KhoaDich; variant: BienTheTrangThai }> = {
  cao: { khoa: 'troLyAiKhoSync.chacCao', variant: 'success' },
  vua: { khoa: 'troLyAiKhoSync.chacVua', variant: 'warning' },
  thap: { khoa: 'troLyAiKhoSync.chacThap', variant: 'neutral' },
};

/**
 * Màu chữ nhãn mức thiệt hại của TỪNG câu phỏng vấn. Bậc `-700` cho chữ trên nền sáng; `kho_doc` cố ý KHÔNG có màu tín
 * hiệu — tô nó lên là làm loãng đúng hai mức cần người ta dừng lại đọc.
 */
export const MAU_HAU_QUA: Record<string, string> = {
  sai_am_tham: 'text-danger-700',
  bi_tu_choi: 'text-warning-700',
  kho_doc: 'text-content-muted',
};

/** Chip lọc theo hậu quả: nền nhạt khi chưa chọn, nền đậm khi đang chọn. */
export const CHIP_HAU_QUA: Record<'danger' | 'warning' | 'neutral', { chon: string; thuong: string }> = {
  danger: { chon: 'bg-danger-600 text-white', thuong: 'bg-danger-50 text-danger-700 hover:bg-danger-100' },
  warning: { chon: 'bg-warning-600 text-white', thuong: 'bg-warning-50 text-warning-700 hover:bg-warning-100' },
  neutral: { chon: 'bg-primary-600 text-white', thuong: 'bg-subtle text-content-secondary hover:bg-primary-50' },
};

/** Trạng thái lần chạy gần nhất của một bảng: chỉ `ok` là xanh; mã lạ đỏ để người vận hành để ý. */
export function bienTheLanChay(ma: string): BienTheTrangThai {
  return ma === 'ok' ? 'success' : ma === 'skipped' ? 'neutral' : 'danger';
}
